// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-ThirdOption_cls1__csAFl","cls2":"SplitMobileFab-ThirdOption_cls2__1qDFg SplitMobileFab-ThirdOption_cls1__csAFl"};